import { html } from 'lit';
import { isEven } from '@outbook/numbers';

export function themeText({ text = 'Loading' }) {
  return html`<div class="progress__item" aria-hidden="true">
    ${text.split('').map((char, index) => {
      return html`<div
        class="progress__item-char column-${isEven(index) ? 'even' : 'odd'}"
      >
        ${char}
      </div>`;
    })}
  </div>`;
}
